import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Creates a Profit Distribution with its selected cutoffs
export const createProfitDistribution = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/profit_distribution/createProfitDistribution`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
